import React, { useState, useRef } from "react";
import { Table, Row, Col, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ExclamationCircle } from "react-bootstrap-icons";
export default function ManualDataPull(props) {
  const [isEnabled, setIsEnabled] = useState(props.isEnabled);
  const [searchConsoleSelected, setSearchConsoleSelected] = useState(false)
  const [open, setOpen] = useState(false);
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Please authenticate shopify url first at account config/website and permissions first.
    </Tooltip>
  );
  const inputRef = useRef();
  const exitIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="rgb(0,0,0)"
        fill-rule="evenodd"
        d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
      />
    </svg>
  );

  const [warningDisplay, setWarningDisplay] = useState(false);

  const calendarForm = (name, defaultDate) => {
    const [startDate, setStartDate] = useState(defaultDate ? defaultDate : new Date());

    const handleStartDateChange = (date) => {
      setStartDate(date);

      if (name === "start_date") {
        const fourteenMonthsAgo = moment().subtract(14, 'months');
        const startDateMoment = moment(date);

        if (startDateMoment.isBefore(fourteenMonthsAgo)) {
          setWarningDisplay(true)
        } else {
          setWarningDisplay(false)
        }
      }
    }

    let aboutSixteenMonthsAgo = moment().subtract(476,'d').format('YYYY-MM-DD')

    const formatDate = (date) => {
      return moment(date).format("YYYYMMDD");
    };

    const calendarRef = useRef();

    return (
      <>
        <div className="d-flex data-pull">
          <div className="dateSelectorPull">
            <i
              style={{ paddingRight: "8px" }}
              onClick={() => {
                calendarRef.current.setOpen(true);
              }}
              className="far f20 fa-calendar-alt"></i>
            <DatePicker
              // minDate={(searchConsoleSelected === true) ? new Date(aboutSixteenMonthsAgo) : undefined}
              ref={calendarRef}
              autoComplete="off"
              dateFormat="MM/dd/yy"
              selected={startDate}
              onChange={handleStartDateChange}
              popperProps={{
                positionFixed: true,
              }}
            />
          </div>
          <input hidden readOnly name={`[pull_platform_data][${props.service}]${name}`} value={formatDate(startDate)} />
        </div>
      </>
    );
  };

  return (
    <div className="dataPull">
      <Row className="pl-md-5 pl-4 py-3 align-items-center">
        <CustomFormCheck
          id={`data-pull-enabled-${props.service}`}
          name={`data_pull_enabled_${props.service}`}
          checked={isEnabled}
          sendUncheckedValue
          onChange={() => {
            setIsEnabled(!isEnabled);
          }}
          label="Enable Manual Data Pulls"
        />
        <CustomTooltip
          faClass="far f16 primary mdpull fa-question-circle pl-2"
          message=" Here you can manually pull data into DataPulse. Select which platforms you would like to pull from and select a date range. Then click Pull Data to import any new available data.
          "
          inline={true}
        />
      </Row>
      {props.platforms.map((platform) => {
        if (platform.name.includes("semrush") && !props.isAdmin) {
          return false;
        } else {
          return (
            <Row key={platform.id} className="pl-5 ml-2 pb-1 align-items-center">
              {platform.name == "shopify" && !props.shopify_connected ? (
                <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                  <a>
                    <CustomFormCheck id={platform.id} label={platform.label} disabled={true} />
                  </a>
                </OverlayTrigger>
              ) : (
                <CustomFormCheck
                  id={platform.id}
                  name={`[pull_platform_data][${props.service}]${platform.name}`}
                  label={platform.label}
                  disabled={!isEnabled}
                  sendUncheckedValue
                  static
                  onChange={platform.name ===("pull_search_console_data") ? ()=> {setSearchConsoleSelected(!searchConsoleSelected)} : undefined}
                />
              )}
            </Row>
          );
        }
      })}
      <Row className="pl-3 pb-2">
        <Col>
          <div className="calendarAdjust d-flex flex-column flex-md-row">
            <div className="d-flex mb-3 justify-content-center">
              <p className="f12 primary mr-2 manual-data-pull-label" style={{ whiteSpace: "nowrap" }}>
                {" "}
                Date range:{" "}
              </p>
              {calendarForm("start_date", moment().subtract(30, "days").toDate(), setWarningDisplay)}
            </div>
            <div className="d-flex justify-content-center">
              <p className="f12 primary mr-2 manual-data-pull-label" style={{ whiteSpace: "nowrap" }}>
                through
              </p>
              {calendarForm("end_date", moment().subtract(1, "days").toDate(), setWarningDisplay)}
            </div>
          </div>
        </Col>
      </Row>
      <Row className="pb-3 pl-4 pr-3 justify-content-center justify-content-md-start">
        <Col xs={"auto"}>
        {warningDisplay ? <p style={{ color: '#FF7999', marginBottom: '10px' }}>DataPulse will only repull GA4 data within the last 14 months</p> : null}
          <Button
            className="mt-0 mb-3 ml-4 mr-4 px-5 py-1 center-mobile-button"
            size="sm"
            as="input"
            type="button"
            value="Save changes and pull data"
            variant="success"
            onClick={() => {
              const values = $('input[name^="[pull_platform_data]"]')
                .map(function () {
                  if ($(this).val() == "1" && $(this).is(":checked")) return $(this).attr("name");
                })
                .get();
              values.length > 0 ? setOpen(true) : inputRef.current.click();
            }}
          />
        </Col>
      </Row>
      <input type="submit" hidden ref={inputRef} />
      <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="alert-dialog-title">
        <DialogTitle id="alert-dialog-title" style={{ color: "#2C345B", fontFamily: "visby-bold", fontSize: "24px" }}>
          <ExclamationCircle style={{ verticalAlign: "text-top" }} /> &nbsp; Important: Initiating Data Pull
        </DialogTitle>
        <div onClick={() => setOpen(false)} style={{ position: "absolute", right: "5px", cursor: "pointer" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" style={{ position: "relative" }}>
            <path
              fill="rgb(0,0,0)"
              fillRule="evenodd"
              d="M8 9.41421356l-4.29289322 4.29289322-1.41421356-1.41421356L6.58578644 8 2.29289322 3.70710678l1.41421356-1.41421356L8 6.58578644l4.29289322-4.29289322 1.41421356 1.41421356L9.41421356 8l4.29289322 4.29289322-1.41421356 1.41421356L8 9.41421356z"
            />
          </svg>
        </div>
        <DialogContent>
          <p style={{ color: "#555555", fontFamily: "nunito-regular", fontSize: "14px" }}>
            You have requested to initiate a data pull, or changes made on this page would require a data pull to proceed.
          </p>
          <p style={{ color: "#2C345B", fontFamily: "nunito-bold", fontSize: "14px" }}>
            A data pull can take up to several hours and you will not be able to access or make changes to this account's associated configuration pages until
            the pull is finished. Please proceed with full certainty!
          </p>
        </DialogContent>
        <div className="d-flex flex-column flex-md-row justify-content-between p-4">
          <Button
            onClick={() => setOpen(false)}
            style={{
              backgroundColor: "#3291c1",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}>
            Hold on, go back
          </Button>
          <Button
            style={{
              backgroundColor: "#42ba96",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}
            onClick={() => inputRef.current.click()}
            autoFocus>
            Save changes and initiate data pull
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
